// extracted by mini-css-extract-plugin
export var wordContainer = "_nv-0";